module.exports = __webpack_public_path__ + "b818abfc2ccc37b4f46fc575e6ba8010.svg";